import React from 'react'

import { formatSubscriptionBytes } from '../../utils/formatSubscriptionBytes'
import * as S from './SubscriptionStorageLabel.styled'

type SubscriptionStorageLabelProps = {
  size: number
}

export const SubscriptionStorageLabel = ({ size }: SubscriptionStorageLabelProps) => {
  return <S.Container>{formatSubscriptionBytes(size)}</S.Container>
}
